<template>
	<div id="app">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
	</div>
</template>

<script>
	export default {
		name: "App",
		methods: {
			getBrowser() {
				let is360 = false;
				let isIE = false;
				if (window.navigator.appName.indexOf("Microsoft") != -1) {
					isIE = true;
				}
				if (isIE && window.navigator.userAgent.indexOf('compatible') != -1) {
					is360 = true;
				}
				if (is360) {
					alert('暂不支持兼容IE浏览器，建议您使用chrome!');
					// document.body.innerText = '360浏览器';
				} else if (isIE) {
					alert('暂不支持该模式，请打开极速模式!');
					// document.body.innerText = 'IE浏览器';
				}
			},
			_isMobile() {
				let flag = window.navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)
				return flag;
			}
		},
		created() {
			this.getBrowser();
		}
	};
</script>

<style>
	* {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		min-width: 100vw;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue